import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import SelectDiscount from '../components/SelectDiscount'

import { addPromotionsToOrder } from '../actions/promotion'
import { startTabOrderAdjustment } from '../actions/order'

import { getPromotions, getSelectedPromotions } from '../selectors/promotion'
import { getOrder } from '../selectors/order'
import { updateExemptions } from '../actions/orderTotalRemote'
import { filter } from 'lodash'

const mapStateToProps = (state, props) => {
  const orderId = props?.match?.params?.orderId
  const order = getOrder(state, orderId)
  const promotions = getPromotions(state)
  let originalSelectedPromotions
  if (orderId) {
    originalSelectedPromotions = filter(order?.createOrderParams?.promotions ?? [], (promotion) => promotion.applies || promotion.applied)
  } else {
    originalSelectedPromotions = getSelectedPromotions(state)
  }

  return {
    promotions,
    originalSelectedPromotions,
    orderId,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const replace = props?.history?.replace ?? (() => {})
  const orderId = props?.match?.params?.orderId ?? ''

  return {
    onClose: () => {
      if (orderId) {
        replace(`/tabs/${orderId}/close`)
      } else {
        replace('/tab-order/pay-now')
      }
    },
    addPromotionsToOrder: (selectedPromotions) => {
      if (orderId) {
        dispatch(startTabOrderAdjustment(orderId, 'update', { calculateRemoteOrderTotal: true, selectedPromotions }))
        dispatch(updateExemptions({ orderUuid: orderId, promotions: selectedPromotions }))
      } else {
        dispatch(addPromotionsToOrder({ selectedPromotions }))
      }
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelectDiscount))
